import { default as i18n } from 'i18next'
import { initReactI18next } from 'react-i18next'

void i18n.use(initReactI18next).init({
  resources: {
    ja: {
      translation: {
        number: {
          default: '{{val, number}}'
        },
        currency: {
          default: '¥{{val, number}}',
        },
        clientAuth: {
          general: {
            email: {
              invalid: 'メールアドレスの形式が正しくありません。'
            }
          }
        },
        job_offer_details: {
          not_found: '求人情報が見つかりませんでした。'
        }
      },
    },
  },
  lng: 'ja',
})

export default i18n
